export function slickSliders() {
  //     var slider = jQuery(".sliderexample-slick-slider");
  //     jQuery('.sliderexample-prev').click(function () {
  //       jQuery('.sliderexample-slick-slider').slick('slickPrev');
  //     })

  //     jQuery('.sliderexample-next').click(function () {
  //       jQuery('.sliderexample-slick-slider').slick('slickNext');
  //     })

  //     slider.slick({
  //         infinite: false,
  //         slidesToShow: 3,            // Display 3 slides at a time (no decimal)
  //         slidesToScroll: 3,          // Scroll 3 slides at a time
  //         arrows: false,
  //         dots: false,
  //         swipe: true,
  //         adaptiveHeight: true,
  //         prevArrow: jQuery('.sliderexample-prev'),
  //         nextArrow: jQuery('.sliderexample-next'),
  //         variableWidth: false,       // Disable variable width to ensure consistent slide width
  //         cssEase: 'ease-in-out',
  //         speed: 2000,                // Default speed for larger screens
  //         responsive: [
  //           {
  //             breakpoint: 992,
  //             settings: {
  //               slidesToShow: 2,      // Show 2 slides at a time for medium screens
  //               slidesToScroll: 2,
  //               speed: 1500           // Faster speed for medium screens
  //             },
  //           },
  //           {
  //             breakpoint: 770,
  //             settings: {
  //               slidesToShow: 1,      // Show 1 slide at a time for smaller screens
  //               slidesToScroll: 1,
  //               speed: 1000           // Even faster speed for small screens
  //             },
  //           },
  //           {
  //             breakpoint: 480,
  //             settings: {
  //               slidesToShow: 1,     
  //               slidesToScroll: 1,
  //               speed: 500           
  //             },
  //           }
  //         ],
  //       });

  //     jQuery(window).on('resize', function () {
  //       slider.slick('refresh');
  //     });
  // }

  jQuery(document).ready(function ($) {
    $('.key-players-slider').slick({
      dots: true,
      infinite: false,
      slidesToShow: 1.2,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      arrows: false,
      lazyLoad: 'progressive',
      adaptiveHeight: true,
      variableWidth: false,
      responsive: [{
        breakpoint: 992,
        settings: {
          adaptiveHeight: false
        }
      }]
    });

    // jQuery(window).on('resize', function () {
    //   $('.key-players-slider').slick('refresh');
    // });
  });
  jQuery(document).ready(function ($) {
    var slider = jQuery(".posts-slider");
    jQuery('.posts-slider-prev').click(function () {
      jQuery('.posts-slider').slick('slickPrev');
    });
    jQuery('.posts-slider-next').click(function () {
      jQuery('.posts-slider').slick('slickNext');
    });
    slider.slick({
      dots: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 0,
      speed: 1000,
      cssEase: 'linear',
      arrows: false,
      adaptiveHeight: true,
      variableWidth: true,
      prevArrow: $('.posts-slider-prev'),
      nextArrow: $('.posts-slider-next')
    });
    jQuery(window).on('resize', function () {
      // slider.slick('refresh');
    });
  });
  jQuery(document).ready(function ($) {
    var slider = jQuery(".texts-slider");
    var totalSlides = slider.find(".text-slide").length; // Total number of slides

    // Add a counter div
    $(".slide-number").text('1 / ' + totalSlides);

    // Navigation buttons
    jQuery('.texts-slider-prev').click(function () {
      jQuery('.texts-slider').slick('slickPrev');
    });
    jQuery('.texts-slider-next').click(function () {
      jQuery('.texts-slider').slick('slickNext');
    });

    // Initialize Slick Slider
    slider.slick({
      dots: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 0,
      speed: 1000,
      cssEase: 'linear',
      arrows: false,
      adaptiveHeight: false,
      variableWidth: true,
      prevArrow: $('.texts-slider-prev'),
      nextArrow: $('.texts-slider-next'),
      responsive: [{
        breakpoint: 500,
        settings: {
          variableWidth: false
        }
      }]
    });

    // Update the counter on slide change
    slider.on('afterChange', function (event, slick, currentSlide) {
      $(".slide-number").text(currentSlide + 1 + ' / ' + totalSlides);
    });
    function setEqualHeight(slider) {
      var maxHeight = 0;

      // Find the tallest slide
      slider.find('.slick-slide').each(function () {
        var thisHeight = $(this).outerHeight();
        if (thisHeight > maxHeight) {
          maxHeight = thisHeight;
        }
      });

      // Apply the tallest height to all slides
      slider.find('.slick-slide').css('height', maxHeight + 'px');
    }

    // Call the function after initializing Slick
    setEqualHeight(slider);

    // Refresh slider on window resize
    jQuery(window).on('resize', function () {
      // slider.slick('refresh');
      setEqualHeight(slider);
    });
  });
  jQuery(document).ready(function ($) {
    // Navigation buttons
    jQuery('.post-types-slider-prev').click(function () {
      jQuery('.post-types-slider').slick('slickPrev');
    });
    jQuery('.post-types-slider-next').click(function () {
      jQuery('.post-types-slider').slick('slickNext');
    });
    $(".post-types-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: false,
      autoplay: false,
      draggable: false,
      swipe: false,
      fade: true,
      cssEase: "linear"
    });
  });
  jQuery(document).ready(function ($) {
    function setEqualHeight(slider) {
      var maxHeight = 0;

      // Find the tallest slide
      slider.find('.slick-slide').each(function () {
        var thisHeight = $(this).outerHeight();
        if (thisHeight > maxHeight) {
          maxHeight = thisHeight;
        }
      });

      // Apply the tallest height to all slides
      slider.find('.slick-slide').css('height', maxHeight + 'px');
    }

    // Initialize the slick slider
    var slider = $('.economic-sectors-slider').slick({
      dots: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 0,
      speed: 500,
      cssEase: 'linear',
      arrows: false,
      adaptiveHeight: true,
      variableWidth: true,
      lazyLoad: 'progressive',
      responsive: [{
        breakpoint: 992,
        settings: {
          adaptiveHeight: false,
          variableWidth: false,
          dots: true
        }
      }]
    });

    // Function to update button classes based on the current slide
    function updateButtonStates(currentSlideIndex) {
      $('.slider-nav-buttons .nav-button').each(function (index) {
        if (index === currentSlideIndex) {
          $(this).removeClass('not-active');
        } else {
          $(this).addClass('not-active');
        }
      });
    }

    // Initial state update
    updateButtonStates(0);

    // Update button classes on slide change
    slider.on('afterChange', function (event, slick, currentSlide) {
      updateButtonStates(currentSlide);
    });

    // Attach click event for navigation buttons
    $('.slider-nav-buttons .nav-button').on('click', function () {
      var slideIndex = $(this).data('slide');
      slider.slick('slickGoTo', slideIndex);
    });

    // Attach click event for prev/next buttons
    $('.slider-controls .prev-slide').on('click', function () {
      slider.slick('slickPrev');
    });
    $('.slider-controls .next-slide').on('click', function () {
      slider.slick('slickNext');
    });
    setEqualHeight(slider);

    // Refresh slider on window resize
    jQuery(window).on('resize', function () {
      // slider.slick('refresh');
      setEqualHeight(slider);
    });
  });
  jQuery(document).ready(function ($) {
    var slider = $('.map-slider');

    // Initialize the slick slider with 3 slides showing at a time
    slider.slick({
      slidesToShow: 3,
      // Show 3 slides at a time
      slidesToScroll: 1,
      // Scroll 1 slide at a time
      arrows: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 1000,
      prevArrow: $('.map-prev'),
      nextArrow: $('.map-next'),
      centerMode: false,
      variableWidth: false,
      infinite: true,
      // Disable infinite scrolling
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          // Show 2 slides on tablets and below
          slidesToScroll: 1 // Scroll 1 slide at a time
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          // Show 1 slide on smaller screens
          slidesToScroll: 1 // Scroll 1 slide at a time
        }
      }]
    });

    // Function to update the visibility of arrows based on the current slide
    function updateArrows() {
      var currentSlide = slider.slick('slickCurrentSlide');
      var totalSlides = slider.slick('getSlick').slideCount;
      var slidesPerGroup = 3; // Default for large screens

      // Adjust slidesPerGroup based on the screen size
      if ($(window).width() <= 768) {
        slidesPerGroup = 1; // Show 1 slide on smaller screens
      } else if ($(window).width() <= 1024) {
        slidesPerGroup = 2; // Show 2 slides on medium screens
      }

      // Calculate if we are on the last set of slides
      var isLastSet = currentSlide + slidesPerGroup >= totalSlides;

      // Hide the Prev button if we're on the first set of slides
      if (currentSlide === 0) {
        $('.map-prev').hide();
      } else {
        $('.map-prev').show();
      }

      // Hide the Next button if we're on the last set of slides
      if (isLastSet) {
        $('.map-next').hide(); // Hide Next button on the last set of slides
      } else {
        $('.map-next').show(); // Show Next button otherwise
      }
    }

    // Function to update the image on slide change
    function updateImageOnSlideChange(nextSlide) {
      var newImage = $('.map-slider .slick-slide[data-slick-index="' + nextSlide + '"]').attr('data-image');

      // Fade out the current image
      $('.img-overlay').css({
        transition: 'opacity 0.5s ease-in-out',
        opacity: 0 // Fade out effect
      });

      // After fade out, change the image and fade it back in
      setTimeout(function () {
        $('.img-overlay').attr('src', newImage).css('opacity', 1);
      }, 500); // Matches the transition time
    }

    // Update arrows visibility on initialization
    // updateArrows();

    // Update arrows visibility and image change after each slide change
    slider.on('afterChange', function (event, slick, currentSlide) {
      // Update the arrows visibility
      // updateArrows();

      // Update image based on the next slide
      // updateImageOnSlideChange(currentSlide + 1); // `currentSlide + 1` will be the next slide
    });

    // Handle image change on before slide change (optional)
    slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      updateImageOnSlideChange(nextSlide); // Update image based on the next slide
    });
  });
}